var App = require('./app');
var appHistory = require('swa-app-core/history');
var CorporateLandingHomePageIndex = require('./corporate-landing-home-page-index');
const jwtSettings = require('swa-bootstrap-data/jwt-settings') ?? {};
const logger = require('swa-log/logger');
var React = require('react');
var ReactRouter = require('react-router');
const servicesConfig = require('./config/services-config');
const { EncryptionProvider } = require('@swa-ui/encryption');
const { getAirSeatSchema } = require('./air-seat-schema');

var IndexRoute = ReactRouter.IndexRoute;
var Route = ReactRouter.Route;
var Router = ReactRouter.Router;

const apiKey = servicesConfig?.defaults?.options?.apiKey;
const channelId = process.env.SITE === 'corporate' ? 'corporate' : 'southwest';

var CorporateLandingHomePageRoutes = (
    <EncryptionProvider
        apiKey={apiKey}
        channelId={channelId}
        jwtSettings={jwtSettings}
        logger={logger}
        schemas={getAirSeatSchema()}
    >  
        <Router history={appHistory}>
            <Route path="/corporate/landing/home-page/" component={App}>
                <IndexRoute component={CorporateLandingHomePageIndex} />
                <Route path="index.html" component={CorporateLandingHomePageIndex} />
            </Route>
            <Route path="*" component={App}>
                <IndexRoute component={CorporateLandingHomePageIndex} />
                <Route path="index.html" component={CorporateLandingHomePageIndex} />
            </Route>
        </Router>
    </EncryptionProvider>
);

module.exports = CorporateLandingHomePageRoutes;
